import { useQueries } from "react-query";
import { fetchIngredientPosts } from "./useGetIngredientPosts";
import { PostList } from "./types/postList.types";

export const getIngredientsPostsApiKey = "getIngredientsPosts" as const;

export type IngredientPostListInner = {
    ingredientId: number;
    posts: PostList[];
};
export type IngredientPostListQuery = IngredientPostListInner | undefined;
export type IngredientPosts = {
    isReady: boolean;
    ingredientPosts: IngredientPostListQuery[];
};

export const useGetIngredientsPosts = (
    ingredientIds: number[],
    companyId?: number,
    campaignId?: number,
): IngredientPosts => {
    const queries = useQueries(
        ingredientIds.map((ingredientId) => ({
            queryKey: [getIngredientsPostsApiKey, ingredientId, companyId, campaignId],
            queryFn: async () => {
                const ingredientPosts = await fetchIngredientPosts(ingredientId, companyId, campaignId);

                const result: IngredientPostListInner = {
                    ingredientId: ingredientId,
                    posts: ingredientPosts,
                };
                return result;
            },
        })),
    );

    const hasAllLoaded = queries.every((query) => query.status === "error" || query.status === "success");

    if (hasAllLoaded === false) {
        return {
            isReady: false,
            ingredientPosts: [],
        };
    }

    const allPosts = queries.map((query) => {
        const data = query.data;
        return data;
    });

    return {
        isReady: true,
        ingredientPosts: allPosts,
    };
};
